export default "__VITE_PUBLIC_ASSET__79271a30__"